import React, { useState } from "react";
import {
  Box,
  Button,
  Container,
  TextField,
  Typography,
  Alert,
  CircularProgress
} from "@mui/material";
import { useNavigate } from "react-router-dom"; 
import { useLocation } from "react-router-dom";

const REACT_APP_EXPRESS_SERVER = process.env.REACT_APP_EXPRESS_SERVER;

const OTPPage = () => {
  const [OTP, setOTP] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const { state } = useLocation();
  const [error, setError] = useState(""); 

  const handleChange = (e) => {
    setOTP(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(""); // Clear previous errors
    setIsLoading(true); // Start loader
    const { email, password } = state || {};

    try {

      const response = await fetch(`${REACT_APP_EXPRESS_SERVER}/loginWithOtp`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: email,
          password: password,
          OTP: OTP,
        }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Sign-in failed. Please try again.");
      }

      const data = await response.json();
      console.log("Sign-in successful with otp:", data);
      alert("Sign-in successful with otp:", data);
      sessionStorage.setItem("username", data.data.username);
      sessionStorage.setItem("email", data.data.email);
      sessionStorage.setItem("vendorNo", data.data.vendorNo);
      navigate("/");
    } catch (error) {
      console.error("Sign-in error:", error);
      setError(error.message); // Set error message
    } finally {
      setIsLoading(false); // Stop loader
    }
  };

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          mt: 8,
          p: 4,
          borderRadius: 2,
          boxShadow: 3,
          backgroundColor: "white",
          textAlign: "center",
        }}
      >
        <img src="https://jms.co.ug/wp-content/uploads/2022/06/JMS_logo-1.png" alt="Logo" style={{ width: 100, marginBottom: 16 }} />
        <Typography variant="h6" gutterBottom>
            OTP Verification
        </Typography>
        <Typography variant="body2" sx={{color:"grey"}} gutterBottom>
            Enter the OTP sent to your email address
        </Typography>
        {/* Error Alert */}
        {error && (
          <Alert severity="error" sx={{ width: "100%", mb: 2 }}>
            {error}
          </Alert>
        )}
        <Box component="form" onSubmit={handleSubmit} sx={{ width: "100%" }}>
          <TextField
            fullWidth
            label="OTP"
            type="text"
            name="otp"
            value={OTP}
            onChange={handleChange}
            sx={{ mb: 2 }}
          />
          <Button
            fullWidth
            variant="contained"
            sx={{ backgroundColor: "#5C2626", color: "white" }}
            type="submit"
          >
            {isLoading ? 
            (
              <CircularProgress size={24} sx={{ color: "white" }} /> // Loader
            ) : (
              "Verify OTP"
            )}
          </Button>
        </Box>
      </Box>
    </Container>
  );
};

export default OTPPage;
